import { Component } from 'preact';
import { Router } from 'preact-router';

import Item from './item';

export default class App extends Component {
	
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
		this.currentUrl = e.url;
	};

	render() {
		return (
			<div id="app">
				<Router onChange={this.handleRoute}>
					<Item path="/" id="000" />
					<Item path="/:id" />
				</Router>
			</div>
		);
	}
}
